import { defineEffect } from '../../../core/effect';

/**
 * **勝敗**（Issue #537）。デュエルが決まった。
 *
 * 開く: `win`。画面の中央に「WIN」。**舞台の設定は変えない**（終わりなので戻す相手が居ない）。
 */
const COLOR = '#ffe58a';

export default defineEffect({
  situation: 'win',
  label: '勝敗',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'duel_end' }],

  layers: [
    {
      id: 'band',
      label: '光の帯',
      part: 'beam',
      at: { screen: [960, 540] },
      props: { color: COLOR, core: 0.4 },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.2 }, { ms: 320, value: 1.2, ease: 'ease_out' }, { ms: 2200, value: 1.2 }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 240, value: 1 }, { ms: 2000, value: 1 }, { ms: 2200, value: 0 }] },
      },
    },
    {
      id: 'label',
      label: 'WIN',
      part: 'text',
      parent: 'band',
      props: { text: 'WIN', size: 200, color: '#fff' },
      tf: {
        scale: { keys: [{ ms: 200, value: 0.4 }, { ms: 600, value: 0.6, ease: 'ease_out' }, { ms: 2000, value: 0.62 }] },
        opacity: { keys: [{ ms: 200, value: 0 }, { ms: 420, value: 1 }, { ms: 2000, value: 1 }, { ms: 2200, value: 0 }] },
      },
    },
  ],
}, 'win_effect.js');
